<!--
 * @Author: Ashley.Liu
 * @Date: 2022-05-05 16:12:18
 * @LastEditTime: 2022-12-12 13:25:47
 * @Description: desc
-->
<template>
  <div class="footer">
    © 2022 Zoom Video Communications, Inc. All rights reserved.
  </div>
</template>
<script>
export default {
  name: 'Footer'
}
</script>
<style lang="scss" scoped>
@import '@/styles/common.scss';
.footer {
  position: fixed;
  box-sizing: border-box;
  text-align: center;
  color: #666;
  font-size: 14px;
  height: $search-footer-height;
  line-height: 22px;
  width: 100%;
  bottom: 0;
  z-index: 1002;
  background: #fff;
  // background-image: linear-gradient(
  //   to right,
  //   transparent 0%,
  //   #fff 20%,
  //   #fff 60%,
  //   transparent 80%,
  //   transparent 100%
  // );
}
</style>
